import { ImageType } from "app/main/pages/general-modals/user-gallery/user-galary.dto"

export const ImageBoxBlock = {
    block(block) {
        return {
            name: 'Image',
            file: block.file ?? '',
            type: 'image',
            uuid: block.uuid ?? 0,
            lock: block.lock ?? 0,
            connected_parent_conditional_id: block.connected_parent_conditional_id ?? [],
            fields: block.fields ?? [],
            image_type: block.image_type ?? ImageType.UserImage,
            position: block.position ?? 'center'
        }
    }
}